// @ts-strict-ignore
import { Component, Input, OnInit } from '@angular/core';
import { LMDimension } from '@modal/cubes/lm-cubes';

@Component({
  selector:    'lm-cube-dimensions-mapping',
  standalone: false,
  templateUrl: './lm-cube-dimensions-mapping.component.html',
  styleUrls: [ './lm-cube-dimensions-mapping.component.scss' ],
})

export class LMCubeDimensionsMappingComponent implements OnInit {
  @Input() cubeBusClass: string;
  @Input() dimensionMapping: Array<LMDimension>;
  @Input() message: string;
  @Input() structures: boolean;
  @Input() hasReportingBasis: boolean;
  @Input() topNodeBaseValues: LMDimensionValues;
  @Input() displayHelpText: boolean;
  public helpText: string;

  public emptyMessage: SohoEmptyMessageOptions;
  ngOnInit(): void {
    if (this.dimensionMapping && this.dimensionMapping.length === 0) {
      this.emptyMessage = {
        title: this.message,
        icon: 'icon-empty-error-loading-new',
        color: 'azure'
      };
    }
    this.helpText = Soho.Locale.translate('FilterDialogHelpInfo');
  }

  public getDimensionMapping(): Array<LMDimension> {
    // Return Updated dimensions and values to the cube cell relation service.
    return this.dimensionMapping;
  }
}
